import { useContext } from 'react';
import { TourContext, type TourApi } from './tourContext';

const inactive: TourApi = {
  start: () => {},
  autoStart: () => {},
  stop: () => {},
  isActive: false,
  activeTourId: null,
  tours: [],
};

/** Outside `TourProvider` (e.g. in isolated tests) this returns a no-op API. */
export function useTour(): TourApi {
  return useContext(TourContext) ?? inactive;
}
